<template>
  <q-dialog
    :visible="visible"
    title="上传进度"
    width="50%"
    :innerScroll="false"
    :showFooter="false"
    @close="onClose"
  >
    <div class="upload-progress-dialog" v-loading="loading" element-loading-text="数据加载中">
      <el-table
        :data="tableData"
        border
        height="350px"
        :header-cell-style="{
          backgroundColor: '#FAFAFA',
        }"
        style="width: 100%"
      >
        <el-table-column prop="fileName" label="文件名" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="taskStatus" label="状态" width="100">
        </el-table-column>
        <el-table-column prop="lastUpdateDate" label="更新时间" width="180"></el-table-column>
        <el-table-column prop="failReason" label="原因" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <!-- <div class="pagination-wrapper">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageNum"
          :page-sizes="[10, 20, 50]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div> -->
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'UploadProgressDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    spuId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.fetchUploadProgress();
        }
      },
      immediate: true
    }
  },
  methods: {
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    // 每页条数变化
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.pageNum = 1;
      this.fetchUploadProgress();
    },
    // 当前页变化
    handleCurrentChange(val) {
      this.pagination.pageNum = val;  
      this.fetchUploadProgress();
    },
    // 获取上传进度数据
    fetchUploadProgress() {
      this.loading = true;
      let params = {
        params: {
          spuId: this.spuId
        }
      }
      this.$q.newProduct.querySliceUploadQuery(params)
        .then((res) => {
          if (res.success) {
            this.tableData = res.data || [];
            // this.pagination.total = res.data.total || 0;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="stylus" scoped>
.upload-progress-dialog {
  padding: 10px 0;
}

.pagination-wrapper {
  margin-top: 15px;
  text-align: right;
}
</style>

